if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            // Prefer drawer when present — cart-notification must not win while cart_type is drawer.
            this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
            this.submitButton = this.querySelector('[type="submit"]');

            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            // const submitButton = this.querySelector('[type="submit"]');
            // if (submitButton.classList.contains('loading')) return;
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            // ivan
            // if (window.matchMedia('(min-width: 750px)').matches) {
            //     if($('.item').length > 0){
            //         flyToCart(evt)
            //     }
            // }
            this.handleErrorMessage();
            // this.cartNotification.setActiveElement(document.activeElement);

            // submitButton.setAttribute('aria-disabled', true);
            // submitButton.classList.add('loading');
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
            this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            if (this.cart) {
                const sectionIds =
                    typeof this.cart.getSectionsRequestIds === 'function'
                        ? this.cart.getSectionsRequestIds()
                        : [...new Set(this.cart.getSectionsToRender().map((section) => section.id))];
                formData.append('sections', sectionIds.join(','));
                const sectionsUrl =
                    typeof window.getCartSectionsUrl === 'function'
                        ? window.getCartSectionsUrl()
                        : window.location.pathname;
                formData.append('sections_url', sectionsUrl);
                this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }
                    const quickAddModal = this.closest('quick-add-modal');
                    if (quickAddModal) {
                        document.body.addEventListener(
                            'modalClosed',
                            () => {
                                setTimeout(() => {
                                    this.cart.renderContents(response);
                                });
                            },
                            { once: true }
                        );
                        quickAddModal.hide(true);
                    } else {
                        this.cart.renderContents(response);
                    }
                    // this.cartNotification.renderContents(response);
                    // if (window.matchMedia('(min-width: 750px)').matches) {
                    //     var html = response.sections['cart-notification-button'];
                    //     const regExp = /(?<=\().*?(?=\))/g;
                    //     let email = html.match(regExp);
                    //     var text = $('.fly-num').text();
                    //     if (text !== '99+99+') {
                    //         var num = parseInt(email[0].trim());
                    //         $('.fly-num').text(num);
                    //     } else {
                    //         var headerHtml = response.sections['cart-icon-bubble'];
                    //         let reg = new RegExp('99+', email[0].trim());
                    //         if (reg.test(headerHtml)) {
                    //             let res = headerHtml.replace(reg, '');
                    //             return res
                    //         }
                    //     }
                    // }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    this.submitButton.classList.remove('loading');
                    this.submitButton.removeAttribute('aria-disabled');
                    // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
                });
        }

        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}
